/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_BankInputs */

const en_clients_field_bank = /** @type {(inputs: Clients_Field_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bank`)
};

const pt_br2_clients_field_bank = /** @type {(inputs: Clients_Field_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banco`)
};

/**
* | output |
* | --- |
* | "Bank" |
*
* @param {Clients_Field_BankInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_bank = /** @type {((inputs?: Clients_Field_BankInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_BankInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_bank(inputs)
	return pt_br2_clients_field_bank(inputs)
});